import { Pipe, PipeTransform } from '@angular/core';
import { EntityDisplay, EntitySlugs } from '@app/shell/menu/menu.component';
import { PlIcon } from '@app/icon-library/icons';
import { isMenuItemMatchingCurrentRoute } from '@shared/pipes/menuItem/menuItem.pipe.utils';

@Pipe({ name: 'menuItemChevron' })
export class MenuItemChevronPipe implements PipeTransform {
  public transform(entity: EntityDisplay | null, routeSlugs: EntitySlugs | null): PlIcon | null {
    if (entity) {
      if (isMenuItemMatchingCurrentRoute(entity, routeSlugs)) {
        return PlIcon.chevron_forward;
      } else {
        return entity.menuItem.iconRight;
      }
    }

    return null;
  }
}
